const MOST_USED = 'MOST_USED';
const ALPHABETICAL = 'ALPHABETICAL';
export const ThemeSortingTypes = Object.freeze({
  MOST_USED,
  ALPHABETICAL
});